module.exports = __webpack_public_path__ + "img/PC4.fcc44b0a.png";